import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
export function WhyUs() {
  const t = useT();
  return <section className="py-12 md:py-16 dark:bg-[#242322] transition-colors duration-300 border-y border-stone-200 dark:border-[#3f3d3c] relative overflow-hidden bg-[#fcfcfc]" id="why-us" data-id="element-2154">
      {/* Subtle decorative accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-orange/40 to-transparent" data-id="element-2155" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2156">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="grid lg:grid-cols-12 gap-6 lg:gap-12 items-end" data-id="element-2157">
          <div className="lg:col-span-6" data-id="element-2158">
            <div className="inline-flex items-center gap-2 mb-3" data-id="element-2159">
              <MapPin className="w-3.5 h-3.5 text-brand-accent" data-id="element-2160" />
              <span className="text-[11px] font-bold text-brand-accent uppercase tracking-[0.14em]" data-id="element-2161">
                {'Local Experts'}
              </span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-stone-900 dark:text-white tracking-tight leading-[1.05]" data-id="element-2162">
              We're the dispatcher.{' '}
              <span className="text-stone-500 dark:text-stone-400" data-id="element-2163">
                We're the driver. We're local.
              </span>
            </h2>
          </div>

          <div className="lg:col-span-6 lg:pl-6 lg:border-l lg:border-stone-200 dark:lg:border-white/10 pt-[10px] pb-[10px]" data-id="element-2164">
            <p className="text-stone-600 dark:text-stone-300 text-base md:text-lg font-medium leading-relaxed mb-4" data-id="element-2165">
              {"Built in the 253, we're on the road across the 206 and 425 daily, delivering gravel, soil, bark, and landscape materials throughout King and Pierce Counties.  Same trucks, same drivers, same dispatcher every load.  \nWhen you call, you're talking directly to the people who will schedule and deliver your materials\u2014giving you faster answers, better service, and dependable local delivery every time.."}
            </p>
            <Link to="/local-vs-national" className="group inline-flex items-center gap-2 text-brand-orange hover:text-brand-orange/80 font-bold text-sm tracking-tight transition-colors" data-id="element-2166">
              <span className="border-b border-brand-orange/30 group-hover:border-brand-orange pb-0.5 transition-colors" data-id="element-2167">
                See how we stack up vs. national marketplaces
              </span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1 shrink-0" data-id="element-2168" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}